
const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');

const { FormattedText } = require('core/i18n').i18n;
// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');

// @ constants
const { currencyExpensesParams } = require('constants/mortgageRequestCurrencyFormats');

const MortgageRequestExpensesItemList = props => {
    const { expensesItemClasses, itemsList } = props;

    const itemClasses = classNames(expensesItemClasses.item);
    const titleClasses = classNames(expensesItemClasses.title);
    const valueClasses = classNames(expensesItemClasses.value);
    const boldTitle = classNames(`${expensesItemClasses.title[0]}--bold`);
    const listClasses = classNames(expensesItemClasses.list);

    const itemList = (text1, text2, bold) => {

        const textTitle = bold
            ? <FormattedText value={text1} className={boldTitle}/>
            : <FormattedText value={text1} />;

        const expensesAmmount = typeof text2 === 'number' ? MortgageRequestCurrencyHelp(currencyExpensesParams(text2)) : text2;
        const spanClasses = classNames(`${expensesItemClasses.value[0]}--text`,
            { [`${expensesItemClasses.value[0]}--bold`] : bold});
        return (
            <li className={itemClasses}>
                <div className={titleClasses}>
                    {textTitle}
                </div>
                <div className={valueClasses}>
                    <span className={spanClasses}>
                        {expensesAmmount}
                    </span>
                </div>
            </li>
        );
    };

    const items = itemsList.map(item => itemList(item.text, item.value, item.boldLetter || false));

    return (
        <ul className={listClasses}>
            {items}
        </ul>
    );
};

MortgageRequestExpensesItemList.propTypes = {
    expensesItemClasses: PropTypes.shape({
        item: PropTypes.array,
        title: PropTypes.array,
        value: PropTypes.array,
        list: PropTypes.array,
    }),
    itemsList: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            value: PropTypes.number
        })
    ).isRequired
};

module.exports = MortgageRequestExpensesItemList;
